const CURSOR_RE =
  /^(\d+):(\d{10,}):([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/iu

export interface LineupLiveCursor {
  eventSequence: number
  createdAtMs: number
  pointEventId: string
}

export function parseLineupLiveCursor(value: string | null | undefined): LineupLiveCursor | null {
  const match = value?.trim().match(CURSOR_RE)
  if (!match) return null

  const eventSequence = Number(match[1])
  const createdAtMs = Number(match[2])
  if (!Number.isSafeInteger(eventSequence) || !Number.isSafeInteger(createdAtMs)) return null

  return {
    eventSequence,
    createdAtMs,
    pointEventId: match[3].toLowerCase()
  }
}

export function serializeLineupLiveCursor(cursor: LineupLiveCursor): string {
  const value = `${cursor.eventSequence}:${cursor.createdAtMs}:${cursor.pointEventId.toLowerCase()}`
  if (!parseLineupLiveCursor(value)) {
    throw new Error('Invalid lineup live cursor.')
  }
  return value
}

export function compareLineupLiveCursors(
  left: LineupLiveCursor,
  right: LineupLiveCursor
): -1 | 0 | 1 {
  if (left.eventSequence !== right.eventSequence) {
    return left.eventSequence < right.eventSequence ? -1 : 1
  }
  if (left.createdAtMs !== right.createdAtMs) {
    return left.createdAtMs < right.createdAtMs ? -1 : 1
  }

  const leftId = left.pointEventId.toLowerCase()
  const rightId = right.pointEventId.toLowerCase()
  if (leftId === rightId) return 0
  return leftId < rightId ? -1 : 1
}
